import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { base_url } from "../Api/Api";

const Header = (props) => {
  const [unreadNotification, setUnreadNotification] = useState(false);

  useEffect(() => {
    base_url
      .get("splash")
      .then((res) => {
        localStorage.setItem(
          "unreadNotification",
          res.data.unread_notifications === 0 ? false : true
        );
        res.data.unread_notifications === 0
          ? setUnreadNotification(false)
          : setUnreadNotification(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div className="Header">
      {props.innerPage ? (
        <span className="cat-title">
          {props.title}
          <i
            className="icon-arrow-down-sign-to-navigate"
            onClick={() => props.history.goBack()}
          ></i>
        </span>
      ) : (
        <span>
          <i className="icon-Group-4044"></i>
        </span>
      )}
      {!props.innerPage ? (
        <div className="noti-search">
          <Link to="/search">
            <i className="icon-search"></i>
          </Link>
          <Link to="/notifications">
            <b
              className={
                localStorage.getItem("unreadNotification") === true ||
                unreadNotification
                  ? "active"
                  : ""
              }
            ></b>
            <i className="icon-stop"></i>
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default withRouter(Header);
